import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalAccountsService } from "services/ClientPortalAccountsService";
import { IClientPortalBudgetsService } from "services/ClientPortalBudgetsService";
import { ClientPortalBudgetChargesModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  Charges: new ClientPortalBudgetChargesModel(),
  Loading: false,
};

export const ClientBudgetHeaderChargesTableSlice = createSlice({
  name: "ClientBudgetHeaderChargesTable",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getChargesForClientsBudgetHeading.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getChargesForClientsBudgetHeading.fulfilled, (state, action) => {
        state.Charges = action.payload;
        state.Loading = false;
      })
      .addCase(getChargesForClientsBudgetHeading.rejected, (state) => {
        state.Charges = new ClientPortalBudgetChargesModel();
        state.Loading = false;
      });
  },
});

export const getChargesForClientsBudgetHeading = createAsyncThunk<
  ClientPortalBudgetChargesModel,
  { clientID: string; budgetID: string; budgetHeaderID: string }
>(
  "ClientBudgetHeaderChargesTable/getChargesForClientsBudgetHeading",
  async ({ clientID, budgetID, budgetHeaderID }) => {
    const budgetsService = container.get<IClientPortalBudgetsService>(SERVICE_TYPES.ClientPortalBudgetsService);
    return await budgetsService.getChargesForClientsBudgetHeading(
      clientID,
      parseInt(budgetID),
      parseInt(budgetHeaderID)
    );
  }
);

export const downloadChargeFilePDF = createAsyncThunk(
  "ClientBudgetHeaderChargesTable/downloadChargeFilePDF",
  async (chargeFileID: string) => {
    const accountsService = container.get<IClientPortalAccountsService>(SERVICE_TYPES.ClientPortalAccountsService);
    return await accountsService.downloadChargeFilePDF(chargeFileID);
  }
);

export const selectCharges = (state: RootState) => {
  return state.clientBudgetHeaderChargesTable.Charges;
};

export const selectLoadingCharges = (state: RootState) => {
  return state.clientBudgetHeaderChargesTable.Loading;
};

export default ClientBudgetHeaderChargesTableSlice.reducer;
